import { UserFileProcessingBlockedReason, UserFileProcessingStatus } from '@/user_files/schemas/processing-status'

export function isWaitingForOcrQuota(file: { processing_status?: string | null; processing_blocked_reason?: string | null } | undefined): boolean {
  return file?.processing_blocked_reason === UserFileProcessingBlockedReason.OcrQuota && !isTerminalProcessingStatus(file.processing_status)
}

/** Terminal for polling: success or failure (not `PENDING` / `PROCESSING`). */
export function isTerminalProcessingStatus(status: string | null | undefined): boolean {
  return status === UserFileProcessingStatus.Completed || status === UserFileProcessingStatus.Failed
}

export function isSelectableProcessingStatus(status: string | null | undefined, includeProcessingFiles = false): boolean {
  return status === UserFileProcessingStatus.Completed || (includeProcessingFiles && status === UserFileProcessingStatus.Processing)
}
